import { CoApplicantPipe } from '@hb/modules/global';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { GlobalControl } from '@hb/domain';
import { SustainabilityStoreService } from '@hb/modules/property/sustainability/sustainability-store.service';
import { AdditionalInfoComponent } from '@hb/modules/global/additional-info';
import { GLOBAL_STORE, GlobalInjectComponent, QUESTION_KEY } from '@hb/modules/global/abstract-global-inject.component';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';

import { Component, inject, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { ApContentModule } from '@ap/content';
import { ApRadioModule } from '@ap/radio';
import { ApButtonGroupComponent, ApButtonGroupItemComponent } from '@ap/button';

@Component({
    selector: 'sustainability-loan',
    templateUrl: './sustainability-loan.component.html',
    standalone: true,
    imports: [
        ApContentModule,
        FormsModule,
        ReactiveFormsModule,
        ApRadioModule,
        ApButtonGroupComponent,
        ApButtonGroupItemComponent,
        AdditionalInfoComponent,
        CoApplicantPipe
    ],
    providers: [
        { provide: GLOBAL_STORE, useExisting: SustainabilityStoreService },
        { provide: QUESTION_KEY, useValue: QuestionKey.SUSTAINABILITY_LOAN_BUTTON_GROUP }
    ]
})
export class SustainabilityLoanComponent extends GlobalInjectComponent<SustainabilityStoreService> implements OnInit {
    private readonly analyticsService = inject(AnalyticsService);
    protected readonly store = inject(SustainabilityStoreService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.mainApplicantControl = new GlobalControl<string>(
            this.analyticsService,
            this.questionKey,
            this.store.getSustainabilityLoan()?.toString()
        );

        this.mainApplicantControl
            .onUpdate()
            .subscribe((sustainabilityLoan) => this.store.setSustainabilityLoan(Boolean(JSON.parse(sustainabilityLoan))));
    }

    onButtonGroupClicked($event: string): void {
        this.mainApplicantControl.setValue($event);
    }
}
